import { DOMAINS, EntityNotifier } from '@bizzabo/realtime-notifier';

import {
    MAX_JOIN_LEAVE_RECONNECT_ATTEMPTS,
    JOIN_LEAVE_RECONNECT_BASE_DELAY_MS,
    JOIN_LEAVE_RECONNECT_MAX_DELAY_MS,
    JOIN_LEAVE_RECONNECT_JITTER_RATIO,
} from '../sessionBroadcastUtils';

const ACTIVITY_NAME = 'session_join_leave';

const SECONDS_TO_INIT_RESET_COUNT = 20;

export class JoinLeaveNotifier extends EntityNotifier {
    constructor({ accountId, eventId, ...notifierConfig }) {
        super({
            ...notifierConfig,
            activity: ACTIVITY_NAME,
            domain: DOMAINS.AGENDA,
            accountId: Number(accountId),
            eventId: Number(eventId),
            clientFacing: true,
            aggressiveRestartMode: true,
            secondsToInitResetCount: SECONDS_TO_INIT_RESET_COUNT,
            skipStateRequestOnConnection: true,
            reconnect: {
                baseDelayMs: JOIN_LEAVE_RECONNECT_BASE_DELAY_MS,
                multiplier: 2,
                maxDelayMs: JOIN_LEAVE_RECONNECT_MAX_DELAY_MS,
                jitterRatio: JOIN_LEAVE_RECONNECT_JITTER_RATIO,
                maxAttempts: MAX_JOIN_LEAVE_RECONNECT_ATTEMPTS,
                resetAfterMs: SECONDS_TO_INIT_RESET_COUNT * 1000,
            },
        });
    }
}
